/**
 * Families Page
 */

import { FolderTree } from 'lucide-react'
import { CatalogPage } from './CatalogPage'
import { useTranslation } from '@/hooks/useTranslation'

export function FamiliesPage() {
  const { t } = useTranslation()

  return (
    <CatalogPage
      icon={FolderTree}
      config={{
        endpoint: 'families',
        basePath: '/families',
        title: t('catalogs.families'),
        newItemLabel: t('catalogs.newFamily'),
        noItemsLabel: t('catalogs.noFamilies'),
        displayField: 'description',
        secondaryField: 'code',
        columns: [
          { key: 'code', header: t('articles.code') },
          { key: 'description', header: t('articles.description') },
        ],
      }}
    />
  )
}
